var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _line, _line2, _rect, _rect2, _rect3, _rect4, _path9, _rect5, _path10, _rect6, _rect7, _rect8, _rect9, _path11, _rect10, _rect11, _rect12, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard1Frame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 637,
    height: 353,
    viewBox: "0 0 637 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M340.382 217.985L340.869 132.04C340.796 130.847 341.562 128.638 345.214 129.354L516.95 129.354C518.716 128.981 522.914 129.534 525.578 134.726L569.492 195.156C570.844 197.021 574.367 200.751 577.638 200.751L634.643 200.751",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M295.156 218.209L295.644 132.183C295.731 130.988 294.99 128.777 291.327 129.494L119.454 129.494C117.691 129.121 113.483 129.674 110.758 134.872L66.122 195.373C64.7473 197.24 61.1794 200.975 57.9056 200.975L0.855406 200.975",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M294.601 316.911L294.56 324.073C294.635 325.117 294.158 327.206 291.656 327.206L221.663 327.206C221.022 327.206 219.265 325.953 217.369 320.94C216.953 319.838 214.995 315.017 212.016 307.735M0.737034 221.79L20.821 221.79M138.139 189.784L138.118 193.365L138.16 185.979M138.139 189.784L149.504 189.784M138.139 189.784L126.774 189.784M149.504 189.784L160.869 189.784C162.985 189.784 164.463 192.172 164.937 193.365C175.141 218.091 191.762 258.404 203.57 287.144M149.504 189.784L149.483 193.365L149.525 185.979M126.774 189.784L115.409 189.784C113.967 189.635 110.404 190.142 107.692 193.365L97.1586 205.787M126.774 189.784L126.754 193.365L126.796 185.979M97.1586 205.787L86.6252 218.209C85.4158 219.402 82.6121 221.79 81.0727 221.79L60.9888 221.79M97.1586 205.787L107.621 205.787L86.6957 205.787M40.9049 221.79L40.8782 226.49M40.9049 221.79L60.9888 221.79M40.9049 221.79L20.821 221.79M60.9888 221.79L60.9621 226.49M20.821 221.79L20.7943 226.49M212.016 307.735L223.698 307.735M212.016 307.735C210.775 304.7 209.356 301.238 207.797 297.439M207.797 297.439L223.756 297.439M207.797 297.439C206.48 294.229 205.064 290.779 203.57 287.144M203.57 287.144L223.815 287.144",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M339.829 316.911L339.788 324.073C339.702 325.117 340.155 327.206 342.656 327.206L412.65 327.206C413.291 327.206 415.062 325.953 417.015 320.94C417.444 319.838 419.456 315.017 422.518 307.735M634.772 221.79L614.689 221.79M497.734 189.784L497.714 193.365L497.756 185.979M497.734 189.784L486.369 189.784M497.734 189.784L509.099 189.784M486.369 189.784L475.004 189.784C472.888 189.784 471.383 192.172 470.895 193.365C460.41 218.091 443.332 258.404 431.197 287.144M486.369 189.784L486.349 193.365L486.391 185.979M509.099 189.784L520.464 189.784C521.908 189.635 525.465 190.142 528.14 193.365L538.533 205.787M509.099 189.784L509.079 193.365L509.12 185.979M538.533 205.787L548.925 218.209C550.121 219.402 552.897 221.79 554.437 221.79L574.521 221.79M538.533 205.787L528.07 205.787L548.995 205.787M594.605 221.79L594.578 226.49M594.605 221.79L574.521 221.79M594.605 221.79L614.689 221.79M574.521 221.79L574.494 226.49M614.689 221.79L614.662 226.49M422.518 307.735L410.836 307.735M422.518 307.735C423.794 304.7 425.252 301.238 426.853 297.439M426.853 297.439L410.894 297.439M426.853 297.439C428.207 294.229 429.662 290.779 431.197 287.144M431.197 287.144L410.953 287.144",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M318.344 201.87L319.35 24.6092C319.355 23.8631 319.844 22.371 321.768 22.371L524.051 22.371C526.295 22.4456 530.789 21.8339 530.806 18.79C530.823 15.7461 530.869 7.6739 530.89 4.01826C530.815 3.12301 531.242 1.33249 533.551 1.33249L625.502 0.999998",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M317.837 201.87L318.843 24.6092C318.848 23.8631 318.376 22.371 316.455 22.371L114.479 22.371C112.238 22.4456 115.85 21.6537 115.867 18.6099C115.884 15.566 115.93 7.49375 115.951 3.83812C116.036 2.94286 107.538 1.33249 105.233 1.33249L11.0158 1.15234",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M317.594 337.726L317.548 345.783C317.376 347.723 318.092 351.602 322.325 351.602L497.188 351.602C498.47 351.751 501.954 350.886 505.637 346.231L563.291 274.162C564.34 272.894 566.872 270.357 568.604 270.357L634.268 270.357",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M316.592 337.726L316.546 345.783C316.695 347.723 315.936 351.602 311.703 351.602L136.84 351.602C135.556 351.751 132.082 350.886 128.452 346.231L71.616 274.162C70.5809 272.894 68.0778 270.357 66.346 270.357L0.68242 270.357",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 97.6548,
    y2: -0.5,
    transform: "matrix(1 1.14686e-09 -0.00567604 0.999984 537.76 22.5947)",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 97.6548,
    y2: -0.5,
    transform: "matrix(1 1.14686e-09 -0.00567604 0.999984 2.34863 22.595)",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 14.772,
    transform: "matrix(1 4.31535e-10 -0.00567604 0.999984 294.429 183.537)",
    fill: "url(#paint0_linear_439_775)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.81825,
    height: 66.6978,
    transform: "matrix(1 4.31535e-10 0.00567604 -0.999984 293.775 325.596)",
    fill: "url(#paint1_linear_439_775)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.81825,
    height: 50.1352,
    transform: "matrix(1 9.1842e-10 -0.00567604 0.999984 317.175 167.423)",
    fill: "url(#paint2_linear_439_775)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1.81825,
    height: 100.718,
    transform: "matrix(1 4.31535e-10 0.00567604 -0.999984 316.402 348.502)",
    fill: "url(#paint3_linear_439_775)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M317 347C317.167 348.333 318.4 351.1 322 351.5",
    stroke: "#D9D9D9",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 14.772,
    transform: "matrix(1 4.31535e-10 -0.00567604 0.999984 339.683 183.537)",
    fill: "url(#paint4_linear_439_775)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M317 347.5C317 348.667 316 351.1 312 351.5",
    stroke: "#D9D9D9",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 1.81825,
    height: 66.6978,
    transform: "matrix(1 4.31535e-10 0.00567604 -0.999984 339.231 325.596)",
    fill: "url(#paint5_linear_439_775)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.03096e-10 -0.00567604 0.999984 620.013 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.03096e-10 -0.00567604 0.999984 605.088 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.03096e-10 -0.00567604 0.999984 590.163 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M575.235 193.664C575.237 193.252 575.573 192.918 575.985 192.918L584.312 192.918C585.417 192.918 586.307 193.813 586.301 194.918L586.297 195.549C586.291 196.568 585.46 197.394 584.441 197.394L578.944 197.394C576.884 197.394 575.223 195.724 575.235 193.664Z",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.03096e-10 -0.00567604 0.999984 16.3057 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.03096e-10 -0.00567604 0.999984 31.2305 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.03096e-10 -0.00567604 0.999984 46.1543 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0749 193.664C61.0772 193.252 60.7451 192.918 60.333 192.918L52.0064 192.918C50.9018 192.918 50.0013 193.813 49.995 194.918L49.9914 195.549C49.9856 196.568 50.8072 197.394 51.8264 197.394L57.3234 197.394C59.3836 197.394 61.0632 195.724 61.0749 193.664Z",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_439_775",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 14.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_439_775",
    x1: 0.909126,
    y1: 0,
    x2: 0.909126,
    y2: 66.6978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_439_775",
    x1: 0.909126,
    y1: 0,
    x2: 0.909126,
    y2: 50.1352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_439_775",
    x1: 0.909126,
    y1: 0,
    x2: 0.909126,
    y2: 100.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_439_775",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 14.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_439_775",
    x1: 0.909126,
    y1: 0,
    x2: 0.909126,
    y2: 66.6978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1Frame2);
export default __webpack_public_path__ + "static/media/card1-frame2.bb666ea706300b290796a7cce8f6fe64.svg";
export { ForwardRef as ReactComponent };